import {
  Box,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography
} from '@mui/material'
import { FC, ReactElement } from 'react'

interface ToolTipContentsProps {
  title: string
  day: string
  startTime: string
  endTime: string
}
const ToolTipContents: FC<ToolTipContentsProps> = ({
  title,
  day,
  startTime,
  endTime
}) => {
  return (
    <Box
      sx={{
        width: '251px',
        minHeight: '67px',
        background: '#ffffff',
        py: '4px',
        px: '8px'
      }}
    >
      <Typography
        sx={{
          fontWeight: '500',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
          textDecoration: 'underline'
        }}
      >
        {title}
      </Typography>

      <Typography
        display='inline'
        fontSize='12px'
        fontWeight='500'
        color='#565656'
      >
        {day}
      </Typography>
      <Typography display='inline' noWrap>
        &nbsp;
      </Typography>
      <Typography
        display='inline'
        fontSize='12px'
        fontWeight='500'
        color='#565656'
      >
        {startTime}
      </Typography>
      <Typography display='inline' noWrap>
        &nbsp;
      </Typography>
      <Typography
        display='inline'
        fontSize='12px'
        fontWeight='400'
        color='#565656'
      >
        -
      </Typography>
      <Typography display='inline' noWrap>
        &nbsp;
      </Typography>
      <Typography
        display='inline'
        fontSize='12px'
        fontWeight='400'
        color='#565656'
      >
        {endTime}
      </Typography>
    </Box>
  )
}

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid #E4E4E4',
    boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.15)',
    fontSize: 11
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white
  }
}))

interface ToolTipProps {
  children: ReactElement<any, any>
  title: string
  day: string
  startTime: string
  endTime: string
  currentView: any
}
export const ToolTip: FC<ToolTipProps> = ({
  children,
  title,
  day,
  startTime,
  endTime,
  currentView
}) => {
  return (
    <>
      {currentView === 'month' || currentView === 'day' ? (
        <LightTooltip
          title={
            <ToolTipContents
              title={title}
              day={day}
              startTime={startTime}
              endTime={endTime}
            />
          }
          arrow
        >
          {children}
        </LightTooltip>
      ) : (
        <Box sx={{ cursor: 'pointer' }}>{children}</Box>
      )}
    </>
  )
}
